import { render } from "./GlTransactions.vue?vue&type=template&id=39bffbc0&scoped=true"
import script from "./GlTransactions.vue?vue&type=script&lang=js"
export * from "./GlTransactions.vue?vue&type=script&lang=js"

import "./GlTransactions.vue?vue&type=style&index=0&id=39bffbc0&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-39bffbc0"

export default script